import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleEnrollClick = () => {
    navigate('/courses');
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-294">
      <button onClick={handleEnrollClick} className="bg-blue-600 text-white px-6 py-3 rounded-full shadow-2xl hover:bg-blue-700 hover:shadow-blue-500/50 hover:scale-110 transition-all duration-300 font-semibold flex items-center gap-2" data-id="element-295">
        Enroll Now
        <span className="text-xl" data-id="element-296">→</span>
      </button>
    </div>;
}